import { Outlet } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import FooterContactUs from './footer-contact-us';

type BaseAppLayoutProps = {
  footerVariant?: 'default' | 'contact';
};

export default function BaseAppLayout({ footerVariant = 'default' }: BaseAppLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow px-4">
        <Outlet />
      </main>
      {footerVariant === 'contact' ? <FooterContactUs /> : <Footer />}
    </div>
  );
}
